import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { ResultPageContainer } from "@/components/ui/result-shell";

/**
 * Shared page chrome for the split-payment result screens
 * (success / error / try-other). Keeps the site header on desktop, hides it on
 * mobile (the designs have no in-page header), and paints the light page
 * background behind a centered content column.
 */
export default function ResultPageShell(_ref) {
  var children = _ref.children,
    _ref$bgClass = _ref.bgClass,
    bgClass = _ref$bgClass === void 0 ? "bg-[#f7f9fc]" : _ref$bgClass;
  return /*#__PURE__*/React.createElement(Layout, {
    hideHeaderOnmobile: true,
    hideFooterWithoutAuthMsg: true,
    hideAppBanner: true,
    mainClass: "SplitPaymentResultPage",
    headHideLinks: true,
    hideOrangeHeadBtn: true
  }, /*#__PURE__*/React.createElement(ResultPageContainer, {
    className: bgClass
  }, children));
}